export let activeLanguage = "eng";
export var serverUrl = "https://3dvam.info/api/";
